<template>
	<div>
		<div class="row program-monitor">
			<!-- input form -->
			<div class="col-md-5" v-if=!isShowRundownList>
				<h3 class="mb-3">{{ $t('SELECT DEVICE TO MONITOR') }}</h3>
				<!-- video -->
				<span>
					<label class="program-monitor-placeholder-input">{{$t('Video Input')}}</label>
					<multiselect class="mb-4 program-monitor-input long" v-model="valueVideo"
						deselect-label="Can't remove this value" track-by="label" label="label"
						placeholder=" " :options="videoOptions" :searchable="false"
						:allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
						</span>
						<template slot="singleLabel"
							slot-scope="{ option }">{{ option.label }}</template>
					</multiselect>
				</span>

				<!-- audio -->
				<span>
					<label class="program-monitor-placeholder-input">{{$t('Audio Input')}}</label>
					<multiselect class="mb-4 program-monitor-input long" v-model="valueAudio"
						deselect-label="Can't remove this value" track-by="label" label="label"
						placeholder=" " :options="audioOptions" :searchable="false"
						:allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
						</span>
						<template slot="singleLabel"
							slot-scope="{ option }">{{ option.label }}</template>
					</multiselect>
				</span>

				<!-- output -->
				<span>
					<label class="program-monitor-placeholder-input">{{$t('Audio Output')}}</label>
					<multiselect class="mb-12 program-monitor-input long" v-model="valueSpeaker"
						deselect-label="Can't remove this value" track-by="label" label="label"
						placeholder=" " :options="speakerOptions" :searchable="false"
						:allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-2 ml-2 size-arrow">expand_more</i>
						</span>
						<template slot="singleLabel"
							slot-scope="{ option }">{{ option.label }}</template>
					</multiselect>
				</span>

				<!-- button add to rundown -->
				<button :disabled="rundowns && !rundowns.length > 0" class="btn btn-primary mt-4"
					@click="showRundownList()">{{$t('Add to Rundown')}}</button>
			</div>
			<!-- show add to rundown -->
			<div class="col-md-5" v-if=isShowRundownList>
				<h3 class="mb-3">{{ $t('SELECT RUNDOWN') }}</h3>
				<!-- button add to rundown -->
				<div v-if="rundowns.length > 0" class="program-monitor-rundown-list mr-2 ml-1"
					id="styleScroll">
					<div v-for="item in rundowns" :key="item.id">
						<ul class="list-nonstyle mb-1">
							<li class="program-monitor-rundown-list-item pl-4 program-monitor-truncate"
								@click="selectedRundown(item)"
								v-bind:class="{'program-monitor-rundown-list-clicked': item.id === rundownId, 'program-monitor-rundown-list-item': !isSelectedRundown}">
								{{ item.name }}
							</li>
						</ul>
					</div>
				</div>
				<div v-else>
					<div class="program-monitor-rundown-list mr-2 ml-1">
						<ul class="list-nonstyle">
							<li class="pl-4">
								<h5>{{$t('No Rundown Available')}}</h5>
							</li>
						</ul>
					</div>
				</div>
				<div class="d-flex justify-content-between">
					<button :disabled="!rundownId" class="btn btn-primary mt-4"
						@click="saveProgramMonitor()">{{$t('Add to Rundown')}}</button>
					<button class="btn btn-secondary mt-4 mr-2"
						@click="cancelAddRundown()">{{$t('Cancel')}}</button>
				</div>
			</div>
			<!-- video and audio meter -->
			<div class="col-md-7">
				<div class="row">
					<div class="program-monitor-videoPreview">
						<video class="mt-1 program-monitor-video" autoplay playsinline
							ref="videoInput">
						</video>
					</div>
					<div>
						<canvas ref="canvas" width="35" height="369"
							style='background:#0E1319'></canvas>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { mapGetters } from 'vuex';
import RTC from 'detectrtc';
import Multiselect from 'vue-multiselect';
import rundownsApi from '@/api/rundowns';
import rundownItemsApi from '@/api/rundownItems';
import {
	getAxiosErrorMessage,
} from '@/lib/helper';

export default {
	name: 'ProgramMonitor',
	components: {
		Multiselect,
	},
	data() {
		return {
			valueAudio: '',
			valueVideo: '',
			valueSpeaker: '',
			valueOthers: null,
			audioOptions: [],
			videoOptions: [],
			speakerOptions: [],
			otherOptions: [],
			detailsDebug: '',
			dialog: false,
			audioContext: null,
			meter: null,
			canvasContext: null,
			WIDTH: 500,
			HEIGHT: 50,
			rafID: null,
			mediaStreamSource: null,
			baseBackground: null,
			stream: null,
			isSaving: false,
			// add to rundown
			rundowns: null,
			isShowRundownList: false,
			isSelectedRundown: false,
			rundownId: '',
			audioStream: null,
		};
	},
	created() {
		if (this.userId) {
			this.fetchRundown();
		}
	},
	mounted() {
		this.initDevices();
	},
	watch: {
		valueVideo(newValueVideo) {
			this.dispatchAction();
			return newValueVideo;
		},
		valueAudio(newValueAudio) {
			this.dispatchAction();
			return newValueAudio;
		},
		valueSpeaker() {
			this.dispatchAction();
		},
	},
	methods: {
		saveProgramMonitor() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				const message = response.message;
				this.$emit('add', item);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Device Monitor',
					text: message,
				});
				this.valueAudio = '';
				this.valueVideo = '';
				this.valueSpeaker = '';
				this.rundownId = '';
				this.isSaving = false;
				this.$emit('done');
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Device Monitor',
					text: message,
				});
				this.isSaving = false;
			};
			rundownItemsApi.create(this.programMonitorParams, callback, errorCallback);
		},
		selectedRundown(rundown) {
			this.isSelectedRundown = true;
			this.rundownId = rundown.id;
		},
		showRundownList() {
			this.isShowRundownList = true;
		},
		cancelAddRundown() {
			this.isShowRundownList = false;
			this.rundownId = '';
		},
		fetchRundown() {
			const callback = (response) => {
				const items = response.data;
				this.rundowns = items;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			const paramsRundown = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_archived: 1,
				user_id: this.userId,
			};
			rundownsApi.getList(paramsRundown, callback, errorCallback);
		},
		setGuideline() {
			const saveArea = '/img/saveAreaMargin.svg';
			this.baseBackground = this.baseBackground === saveArea ? null : saveArea;
		},
		start() {
			let analyser;
			let microphone;
			let javascriptNode = null;
			navigator.getUserMedia = navigator.getUserMedia
				|| navigator.webkitGetUserMedia
				|| navigator.mozGetUserMedia;
			if (navigator.getUserMedia) {
				navigator.getUserMedia({
					audio: {
						deviceId: this.valueSpeaker,
					},
				},
				(stream) => {
					this.audioContext = new AudioContext();
					analyser = this.audioContext.createAnalyser();
					microphone = this.audioContext.createMediaStreamSource(stream);
					javascriptNode = this.audioContext.createScriptProcessor(2048, 1, 1);

					analyser.smoothingTimeConstant = 0.8;
					analyser.fftSize = 1024;

					microphone.connect(analyser);
					analyser.connect(javascriptNode);
					javascriptNode.connect(this.audioContext.destination);

					const canvasContext = this.$refs.canvas.getContext('2d');
					this.audioStream = stream;
					javascriptNode.onaudioprocess = () => {
						const array = new Uint8Array(analyser.frequencyBinCount);
						analyser.getByteFrequencyData(array);
						let values = 0;

						const length = array.length;
						for (let i = 0; i < length; i++) {
							values += (array[i]);
						}

						const average = values / length;
						// Create gradient
						const grd = canvasContext.createLinearGradient(0, 0, 100 - average, 300);
						grd.addColorStop(0, 'green');
						grd.addColorStop(0.4, 'orange');
						grd.addColorStop(0.8, 'yellow');
						grd.addColorStop(1, 'green');
						// Fill with gradient
						canvasContext.fillRect(10, 10, 150, 80);
						canvasContext.clearRect(0, 0, 150, 300);
						canvasContext.fillStyle = grd; // was BadA55 (very cute)
						canvasContext.fillRect(0, 300 - average, 150, 300);
					}; // end fn stream
				},
				() => {
				});
			}
		},
		goToSuperSource() {
			this.$emit('goToSuperSource');
		},
		initDevices() {
			const that = this;
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'audioinput') {
						that.audioOptions.push(device);
					} else if (device.kind === 'videoinput') {
						that.videoOptions.push(device);
					} else if (device.kind === 'audiooutput') {
						that.speakerOptions.push(device);
					} else {
						that.otherOptions.push(device);
					}
					return device;
				});
			});
		},
		attachSinkId(element, sinkId) {
			// eslint no-empty: "error"
			if (typeof element.sinkId !== 'undefined') {
				element.setSinkId(sinkId)
					.then(() => {
						// empty
					})
					.catch(() => {

					});
			} else {
				// empty
			}
		},
		dispatchAction() {
			const video = this.$refs.videoInput;
			try {
				navigator.mediaDevices.getUserMedia({
					video: { deviceId: this.valueVideo ? { exact: this.valueVideo.deviceId } : undefined },
					audio: { deviceId: this.valueAudio ? { exact: this.valueAudio.deviceId } : undefined },
				})
					.then((stream) => {
						window.AudioContext = window.AudioContext || window.webkitAudioContext;
						this.start();
						this.audioContext = new AudioContext();
						this.attachSinkId(video, this.valueSpeaker.deviceId);
						video.srcObject = stream;
						this.stream = stream;
					});
			} catch (err) {
				// cant empty err
			}
		},
		stopVideoOnly() {
			if (this.stream) {
				this.stream.getTracks().forEach((track) => {
					track.stop();
				});
			}
			if (this.audioStream) {
				this.audioStream.getTracks().forEach((track) => {
					track.stop();
				});
			}
		},
	},
	beforeDestroy() {
		this.stopVideoOnly();
	},
	destroyed() {
		this.stopVideoOnly();
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			return this.user && this.user.id ? this.user.id : '';
		},
		programMonitorParams() {
			const content = {
				videoId: this.valueVideo.deviceId,
				audioId: this.valueAudio.deviceId,
				programAudioOutput: this.valueSpeaker,
				width: 1920,
				height: 1080,
				position: 'default',
				x: 0,
				y: 0,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: 'Device Monitor',
				type: 'video_input',
				content: contentString,
				layer_index: 1,
				status: 1,
				is_play_live: 0,
				is_play_preview: 0,
				rundown_id: this.rundownId,
				is_shy: 0,
			};
			return params;
		},
	},
};

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>
